function Footer() {
    return (
        <footer className="bgForHeader text-light py-2 text-center">
            Copyright &copy; { new Date().getFullYear() }
        </footer>
    );
  }
  
  export default Footer;